import { VPS_HEALTH_ENDPOINT } from "@/config/backend";

export interface VpsHealthResult {
  online: boolean;
  status: number;
  data?: any;
  error?: string;
}

/**
 * Check if the VPS backend is reachable and healthy.
 * Calls GET /api/health.php on the production backend.
 */
export async function checkVpsHealth(): Promise<VpsHealthResult> {
  try {
    const res = await fetch(VPS_HEALTH_ENDPOINT, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (!res.ok) {
      return {
        online: false,
        status: res.status,
        error: `HTTP ${res.status}: ${res.statusText}`,
      };
    }

    let data: any;
    try {
      data = await res.json();
    } catch {
      data = null;
    }

    return {
      online: true,
      status: res.status,
      data,
    };
  } catch (err) {
    return {
      online: false,
      status: 0,
      error: err instanceof Error ? err.message : "Network error",
    };
  }
}